document.addEventListener('DOMContentLoaded', () => iniciarHeader());

function iniciarHeader(){
    const barras = document.querySelector("#barras");
    const menu = document.querySelector('#menu');

    if(barras && menu){
        barras.addEventListener('click', () => {
            menu.classList.toggle('mostrar');
            barras.classList.toggle('activo');
        });
    }
}